import { Check, Minus, Sparkles, Star } from "lucide-react";

const SAMPLE = [
  { t: "Box breathing", d: "Stress down 3.1 points on average", w: "Helps most in the evening", n: 12, pin: true },
  { t: "A short walk", d: "Mood 1.4 points higher on days with this", w: "Good-day ingredient", n: 18 },
  { t: "Reframing a thought", d: "Eased a hard thought's grip by 24 points", w: "Helps most when you're anxious", n: 6 },
];
const ROWS = [
  ["One payment, yours for life", "A yearly subscription"],
  ["A playbook built from your own data", "The same content for everyone"],
  ["An AI companion that remembers what helped you", "Generic tips"],
  ["Supporters built in: notes, letters, check-ins", "Going it alone"],
  ["Export or delete your data anytime", "Data that's hard to take with you"],
];

const SamplePlaybook = () => (
  <div className="relative rounded-[32px] bg-white p-5 sm:p-6 shadow-xl border border-mm-primary/10" data-testid="landing-sample-playbook">
    <span className="absolute -top-3 right-5 rounded-full bg-[#3A2E4F] text-white text-[11px] font-bold px-3 py-1" data-testid="landing-sample-tag">Example</span>
    <div className="text-xs font-semibold uppercase tracking-wider text-mm-muted">What Helps Me · Alex's playbook</div>
    <div className="mt-4 space-y-3 mm-stagger">
      {SAMPLE.map((s) => (
        <div key={s.t} className={`rounded-2xl p-4 bg-[#F7F4FD] ${s.pin ? "ring-2 ring-[#F5D76E]" : ""}`}>
          <div className="flex items-center justify-between gap-2"><span className="font-bold">{s.t}</span>{s.pin && <Star size={15} className="text-[#D9A400] fill-current" />}</div>
          <div className="text-sm mt-0.5">{s.d}</div>
          <div className="flex justify-between gap-2 mt-1 text-xs"><span className="text-mm-primary font-semibold">{s.w}</span><span className="text-mm-muted">Based on {s.n} times</span></div>
        </div>
      ))}
      <div className="rounded-2xl p-4 bg-[#FFF4DF] text-[#5A4520] text-sm">🌤️ After two short-sleep nights, the next day is often tougher. A gentle heads-up.</div>
      <div className="rounded-2xl p-4 bg-[#3A2E4F] text-white text-sm"><span className="font-semibold">Mia:</span> “Last time you felt like this, box breathing and a short walk helped. Want to try one now?”</div>
    </div>
  </div>
);

const Compare = () => (
  <div className="mt-14 rounded-[28px] border border-mm-primary/15 overflow-hidden" data-testid="landing-compare">
    <div className="grid grid-cols-2 bg-[#F3EEFC] text-sm font-bold">
      <div className="p-4 text-mm-primary">Mindful Me</div><div className="p-4 text-mm-muted">Typical subscription apps</div>
    </div>
    {ROWS.map(([a, b], i) => (
      <div key={a} className={`grid grid-cols-2 text-sm ${i % 2 ? "bg-white/60" : "bg-white"}`} data-testid={`landing-compare-row-${i}`}>
        <div className="p-4 flex gap-2"><Check size={16} className="text-[#2F7A45] shrink-0 mt-0.5" />{a}</div>
        <div className="p-4 flex gap-2 text-mm-muted"><Minus size={16} className="shrink-0 mt-0.5" />{b}</div>
      </div>
    ))}
  </div>
);

export const PlaybookShowcase = () => (
  <section id="playbook" className="max-w-6xl mx-auto px-5 sm:px-8 mt-28" data-testid="landing-playbook">
    <div className="grid lg:grid-cols-2 gap-12 items-center">
      <div>
        <span className="mm-chip !cursor-default !text-xs"><Sparkles size={13} />Your personal playbook</span>
        <h2 className="text-3xl sm:text-4xl font-bold mt-3">The app that learns what helps <em className="text-mm-primary not-italic underline decoration-wavy decoration-[#F5D76E] underline-offset-8">you</em></h2>
        <p className="text-mm-muted mt-4 max-w-lg">Every check-in and every tool you try quietly builds your personal “What Helps Me” playbook: your top helpers, the moments they work best, your good-day ingredients and gentle early signs.</p>
        <ul className="mt-6 space-y-2 text-sm">
          {["One tap “Did that help?” after any tool", "Mia remembers what worked and suggests it on hard days", "It shows up in SOS Calm and after tough check-ins", "Pin what works, hide what doesn't, add your own"].map((t) => <li key={t} className="flex gap-2"><Check size={16} className="text-mm-primary shrink-0 mt-0.5" />{t}</li>)}
        </ul>
      </div>
      <SamplePlaybook />
    </div>
    <Compare />
  </section>
);
